import {
  SHOW_MODAL,
  CLEAR_MODAL,
  EMAIL_ORDER,
  CREATE_USER,
  UPDATE_USER,
  CREATE_TASK,
  UPDATE_TASK,
  CREATE_ITEM,
  UPDATE_ITEM,
  CREATE_ASSET,
  UPDATE_ASSET,
  DELETE_ASSET,
  ASSIGN_ASSET,
  CREATE_ORDER,
  UPDATE_ORDER,
  CREATE_PEOPLE,
  UPDATE_PEOPLE,
  CREATE_STORAGE,
  CREATE_CUSTOMER,
  UPDATE_CUSTOMER,
  CREATE_WAREHOUSE,
  UPDATE_WAREHOUSE,
  CREATE_INTEGRATION,
  UPDATE_INTEGRATION,
  DELETE_INTEGRATION,
  GET_ORDER_SETTINGS,
  UPDATE_ITEM_QUANTITY,
  CREATE_ORDER_SETTINGS,
  UPDATE_ORDER_SETTINGS,
  UPDATE_ASSIGNED_ASSET,
  NOTIFICATION_SETTINGS,
} from 'actions/types';
import { transformActions } from 'utils/';
import { ITEM_CREATED_MODAL } from 'constants/modal';

const initialState = { type: '', initialValue: null };

/**
  @description Sets modal state shown | hidden
  @param {{}} state
  @param {{}} action
  @returns {{}}
 */
function modal(state = initialState, action) {
  const { type, payload } = action;
  const actions = [
    EMAIL_ORDER,
    CREATE_USER,
    UPDATE_USER,
    CREATE_TASK,
    UPDATE_TASK,
    UPDATE_ITEM,
    ASSIGN_ASSET,
    CREATE_ASSET,
    UPDATE_ASSET,
    DELETE_ASSET,
    CREATE_ORDER,
    UPDATE_ORDER,
    CREATE_PEOPLE,
    UPDATE_PEOPLE,
    CREATE_STORAGE,
    CREATE_CUSTOMER,
    UPDATE_CUSTOMER,
    CREATE_WAREHOUSE,
    UPDATE_WAREHOUSE,
    CREATE_INTEGRATION,
    UPDATE_INTEGRATION,
    DELETE_INTEGRATION,
    GET_ORDER_SETTINGS,
    CREATE_ORDER_SETTINGS,
    UPDATE_ORDER_SETTINGS,
    UPDATE_ASSIGNED_ASSET,
    NOTIFICATION_SETTINGS,
  ];
  if (type === `${UPDATE_ITEM_QUANTITY}_SUCCESS`) {
    return initialState;
  }
  const success = transformActions(actions, 'SUCCESS');
  if (type === SHOW_MODAL) {
    return payload;
  }
  if (type === CLEAR_MODAL) {
    if (state && payload.type === state.type) {
      return initialState;
    }
  }
  if (type === `${CREATE_ITEM}_SUCCESS`) {
    return { initialValue: payload, type: ITEM_CREATED_MODAL };
  }
  if (success.includes(type)) {
    return initialState;
  }
  return state;
}

export default modal;
